import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceDetailTable extends Layout {
    sourceMiscBillDetail: DataSource;
    tableMiscInvoiceDetail: Table;
}
